import FormSwiftAPIClient from 'FormSwiftAPI/FormSwiftAPIClient';
import { saveFreeWriteContent } from '../../FreeWriteBuilder/FreeWriteBuilderActions';
import { EditorOverlayActionTypes } from '../EditorOverlayConstants';
import { SET_EDITOR_MODE, SET_EDITOR_MODE_ERROR } from './ActionTypes';

const formSwiftAPIClient = new FormSwiftAPIClient(window.API_URL);

const getActionTypesForMode = (mode) => {
  if (EditorOverlayActionTypes[mode]) {
    return EditorOverlayActionTypes[mode];
  }
  return {};
};

const actionType = (mode) => {
  const types = getActionTypesForMode(mode);
  if (types.type) {
    return types.type;
  }
  return SET_EDITOR_MODE;
};

const actionErrorType = (mode) => {
  const types = getActionTypesForMode(mode);
  if (types.error) {
    return types.error;
  }
  return SET_EDITOR_MODE_ERROR;
};

/**
 * Set the editor mode for the current session.
 * @arg mode - The new editor mode
 * @arg persist (default true) - If true, the new mode is persisted to the API.
 */
const updateEditorMode = (mode, persist = true) => {
  const currentMode = window.ReactCompatibility.getState().EditorStateHandler.mode;
  let updatedMode = mode || currentMode;
  return async (dispatch) => {
    if (persist) {
      try {
        await formSwiftAPIClient.saveEditorMode(updatedMode);
      } catch (e) {
        const type = actionErrorType(updatedMode);
        const action = { type, error: e.message };
        if (type === SET_EDITOR_MODE_ERROR) {
          action.mode = updatedMode;
        }
        dispatch(action);
        updatedMode = currentMode;
      }
    }
    if (updatedMode !== currentMode) {
      const type = actionType(updatedMode);
      const action = { type };
      if (type === SET_EDITOR_MODE) {
        action.mode = updatedMode;
      }
      dispatch(action);
    }
    if (window.Editor.mode !== updatedMode) {
      window.Editor.mode = updatedMode;
      if (persist) {
        dispatch(saveFreeWriteContent());
      }
    }
  };
};

export default updateEditorMode;



// WEBPACK FOOTER //
// ./src-react/EditorOverlay/EditorOverlayActions/updateEditorMode.jsx